<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box ">
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="openAddBox()"
        >
          新增
        </el-button>
        <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          :disabled="selectedDataList.length == 0 ? true : false"
          @click="delDataInfo()"
        >
          删除
        </el-button>
      </div>
      <div class="search_box ">
        <el-select
          v-model="requestData.diningId"
          placeholder="请选择"
          size="mini"
        >
          <el-option
            v-for="item in canteenList"
            :key="item.id"
            :label="item.diningRoomName"
            :value="item.id.toString()"
          >
          </el-option>
        </el-select>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData"
        >
          搜索
        </el-button>
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="selectActionData"
        >
          <el-table-column type="selection" width="40"> </el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>

          <el-table-column prop="monitorChannel" label="通道号" align="center">
          </el-table-column>

          <el-table-column prop="monitorName" label="摄像头名称" align="center">
          </el-table-column>

          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="delDataInfo(scope.row.id)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="添加食堂摄像头"
      :visible.sync="addBox"
      :append-to-body="true"
      direction="ltr"
      size="30%"
      :wrapperClosable="false"
      :close-on-press-escape="false"
    >
      <div style="height:100%;padding:5px">
        <form class="form-horizontal">
          <div class="form-group">
            <div class="col-sm-12">
              <select class="form-control" v-model="monitorAreaId">
                <option
                  v-for="(value, key) in monitorAreaList"
                  :key="key"
                  :value="value.id"
                  >{{ value.areaName }}</option
                >
              </select>
            </div>
          </div>
        </form>
        <el-table :data="monitorAreaCameraList" 
          height="90%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }">
          <el-table-column type='index' label="序号" width="80"  align="center"> </el-table-column>
          <el-table-column prop="monitorName" label="监控通道名称" align="center">
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="rowData">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="addDataAction(rowData.row.monitorId)"
                >添加</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BrightKitchen from "@/components/BrightKitchen";
export default {
  name: "",
  components: { BrightKitchen },
  props: {},
  data() {
    return {
      addBox: false,
      canteenList: [],
      requestData: {
        diningId: "",
        pageSize: 20,
        pageNum: 1
      },
      responseData: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
        pages: 0,
        list: []
      },
      selectedDataList: [],
      // 已选择的监控区域ID
      monitorAreaId: "",

      monitorAreaList: [],
      monitorAreaCameraList: [],
    };
  },
  watch: {
    monitorAreaId() {
      if (this.monitorAreaId == "") {
        this.monitorAreaCameraList = [];
        return false;
      }
      this.getMonitorList();
    }
  },
  computed: {},
  methods: {
    // 打开新增
    openAddBox() {
      this.addBox = true;
      this.getMonitoringArea();
    },
    // 删除
    delDataInfo(thisId = "") {
      if (thisId != "") {
        var requestData = [thisId];
        // console.log(requestData)
      } else {
        if (this.selectedDataList.length < 1) {
          this.$message("请先选择您要删除的数据");
          return;
        }
        var requestData = this.selectedDataList;
      }
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await this.$Http.delCanteenCamera(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {
            this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 获取监控区域
    async getMonitoringArea() {
      var newParamData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getMonitoringArea(newParamData);
      if (res.code == 200) {
        this.monitorAreaList = res.data || []
        if (this.monitorAreaList.length > 0) {
            this.monitorAreaId = this.monitorAreaList[0].id || ''
            this.getMonitorList()
        }
      } else if (res.code == 101) {
          this.monitorAreaList = []
      } else {
          this.monitorAreaList = []
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取监控列表
    async getMonitorList() {
      var newParamData = {
        schoolId: this.$store.state.schoolId,
        monitorAreaId: this.monitorAreaId
      };
      let res = await this.$Http.getMonitorList(newParamData);
      if (res.code == 200) {
        this.monitorAreaCameraList = res.data;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 添加数据
    async addDataAction(id) {
      var parameData = {
        monitorId: id,
        diningId: this.requestData.diningId
      };
      let res = await this.$Http.addCanteenCamera(parameData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.addBox = false;
        this.monitorAreaId = "";
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取食堂(明厨亮灶)
    async getCanteenList() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getCanteenCameraCanteenList(req);
      if (res.code == 200) {
        this.canteenList = res.data || [];
        if (this.canteenList.length > 0) {
          this.requestData.diningId = this.canteenList[0].id.toString();
          if (this.requestData.diningId != "") {
            this.getDataList();
          }
        }
      } else if (res.code == 101) {
        this.canteenList = [];
        this.responseData.list = []
        this.responseData.total = 0
      } else {
        this.responseData.list = []
        this.responseData.total = 0
        this.$message({
          type: "info",
          message: res.messsage
        });
      }
    },
    searchData(){
      this.requestData.pageNum = 1;
      this.getDataList();
    },
    // 获取数据列表
    async getDataList() {
      let res = await this.$Http.getCanteenCameraList(this.requestData, true);
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        this.responseData.list = res.data.list;
        // console.log(this.responseData.list)
      } else if (res.code == 101) {
        this.responseData.list = []
        this.responseData.total = 0
      } else {
        this.responseData.list = []
        this.responseData.total = 0
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    selectActionData(selectData) {
      this.selectedDataList = [];
      // console.log(selectData)
      selectData.forEach((element) => {
        // console.log(element)
        this.selectedDataList.push(element.id);
      });
      // console.log(this.selectedDataList)
    },
    // 数据翻页
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getDataList();
    }
  },
  created() {
    this.getCanteenList();
  },
  mounted() {}
};
</script>
<style scoped>
.select-li {
  width: 100%;
  height: 54px;
}
.camera-operate {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.content_center_three {
  height: 76%;
}
</style>
